import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { KisListServable } from '../../interfaces/kis-list-servable.interface';
import { KisRestService } from '../action/kis.rest.service';
import { KisList } from '../../models/kis-list.model';
import { Kis } from '../../models/kis.model';
import { KisMappingService } from '../mapping/kis-mapping.service';
import { ApiKis } from '../../models/api-kis.model';
import { ApiKisList } from '../../models/api-kis-list.model';
import { ApiKisMap } from '../../models/api-kis-map.model';
import notify from 'devextreme/ui/notify';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class KisRestAdapterService implements KisListServable {
  constructor(private kisRestService: KisRestService, private kisMappingService: KisMappingService, private _location: Location) {}

  getKis(id: number): Observable<Kis> {
    const resultSubject = new ReplaySubject<Kis>(1);

    this.kisRestService.getKis(id).subscribe((apiKis: ApiKis) => {
      resultSubject.next(this.kisMappingService.mapEntry(apiKis));
    });

    return resultSubject.asObservable();
  }

  getKisByProtocolId(protocolId: string): Observable<Kis> {
    const resultSubject = new ReplaySubject<Kis>(1);

    this.kisRestService.getKisByProtocolId(protocolId).subscribe((apiKis: ApiKis) => {
      if (apiKis) {
        resultSubject.next(this.kisMappingService.mapEntry(apiKis));
      } else {
        // KIS data was null, because someone else deleted the connection, reload data is necessary.
        notify({
          message:
            'Der verknüpfte KIS Datensatz konnte nicht gefunden werden. Die Seite wird neu geladen. Öffnen Sie KIS Import bitte erneut.',
          type: 'Warning',
          displayTime: 5000,
        });
        this._location.back();
      }
      // if error message appears again, check if protocolId is taken instead of nidId - compare join in database
      // check #WEB-967 for more information
    });

    return resultSubject.asObservable();
  }

  getKisList(): Observable<KisList> {
    const resultSubject = new ReplaySubject<KisList>(1);

    this.kisRestService.getKisList().subscribe((apiKisList: ApiKisList) => {
      const kisList: KisList = [];

      if (apiKisList === null || apiKisList === undefined || apiKisList.data === undefined || apiKisList.data.length === 0) {
        resultSubject.next(kisList);
        return;
      }

      for (const apiKis of apiKisList.data) {
        kisList.push(this.kisMappingService.mapEntry(apiKis));
      }
      resultSubject.next(kisList);
    });

    return resultSubject;
  }

  mapKis(id: number, nidaId: string, protocolId: number, exportAt?: Date): Observable<Kis> {
    const resultSubject = new ReplaySubject<Kis>(1);
    const body: ApiKisMap = {
      nidaId,
      protocolId,
    };

    if (exportAt) {
      body.exportAt = exportAt;
    }

    this.kisRestService.mapKis(id, body).subscribe((apiKis: ApiKis) => {
      console.log(apiKis, 'apiKis 4');
      resultSubject.next(this.kisMappingService.mapEntry(apiKis));
    });

    return resultSubject;
  }

  unmapKis(id: number): Observable<Kis> {
    const resultSubject = new ReplaySubject<Kis>(1);

    this.kisRestService.unmapKis(id).subscribe((apiKis: ApiKis) => {
      console.log(apiKis, 'apiKis 5');
      resultSubject.next(this.kisMappingService.mapEntry(apiKis));
    });

    return resultSubject;
  }
}
